import { render } from "./ImprintPage.vue?vue&type=template&id=497fa1cf&scoped=true"
import script from "./ImprintPage.vue?vue&type=script&lang=js"
export * from "./ImprintPage.vue?vue&type=script&lang=js"

import "./ImprintPage.vue?vue&type=style&index=0&id=497fa1cf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-497fa1cf"]])

export default __exports__